import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import SetupMenu from './SetupMenu';
import WingsDropDown from '../Shared/WingsDropDown';
import SessionsDropDown from "../Shared/SessionsDropDown";
import Pagination from "../General/Pagination";
import { scrollToTop } from '../Shared/ScrollOnTop';

const ManageClasses = () => {


    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [Wing_ID, setWing_ID] = useState("");
    const [SessionID, setSessionId] = useState(localStorage.getItem("DefaultSession"));
    const [listOfLedger, setLedger] = useState([]);
    const [isUpdated, setIsUpdated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [WingName, setWingName] = useState("");

    const [ClassName, setClassName] = useState("");


    // pagination 
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    useEffect(() => {
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // Retrieve individual parameter values
        const WingID = urlParams.get('Wing');

        //console.log(WingID);

        if (WingID) {
            setWing_ID(WingID);
        }


    }, []);

    useEffect(() => {

        setIsUpdated(true);
        document.title = "Manage Classes";

        const dashboardParms = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            PageNo: pageNo,
            PageSize: pageSize,
            Wing_Id: Wing_ID,
            SessionID: SessionID
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'WingClass/GetClassesByWingnSessionID',
            headers: {
                'Content-Type': 'application/json'
            },
            data: dashboardParms
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code != 0) {
                    setLedger(response.data.ListofRecords || []);
                    setTotalRecords(response.data.ListofRecords.length || 0);
                    setIsUpdated(false);
                }
                else {
                    setLedger(null);
                    setTotalRecords(0);
                    setIsUpdated(false);
                }

            })
            .catch(function (error) {
                //console.log(error);
            });

    }, [Wing_ID, SessionID, isUpdated]);

    const handlePageChange = (page) => {
        setPageNo(page);
    };


    const renderLedger = () => {

        if (listOfLedger != null && listOfLedger.length > 0) {
            return (
                listOfLedger.map((item, index) => {
                    return (
                        <tr key={index}>

                            <td>{item.Class_Id}</td>
                            <td>{item.Class_Code}</td>
                            <td>{item.Class_Short_Name}</td>
                            <td>{item.Class_Name}</td>
                            <td>{item.SelectedWing.Wing_Name}</td>
                            <td>{item.Selected_Session.Session_Name}</td>
                            <td>
                                <ul className="inline-action">
                                    <li><NavLink to={'/Setup/EditClass/' + item.Class_Id} className=" green"><i className="ri-edit-line"></i></NavLink></li>
                                    <li><NavLink
                                        to={`/Setup/ManageSection?Wing_ID=${Wing_ID}&Class_Id=${item.Class_Id}&Session=${item.Selected_Session.Session_Name}`}
                                        className=" blue">
                                        <i className="ri-list-check"></i></NavLink></li>
                                    <li><button onClick={(e) => deleteClass(item.Class_Id)} className="red"><i className="ri-delete-bin-line"></i></button></li>
                                    <li><NavLink to={`/PrintReports/Classwiseattendancesheet/` + item.Class_Id} target="_blank" className="blue"><i className="ri-printer-line"></i></NavLink></li>
                                </ul>
                            </td>
                            <td className="">
                                <div className="dropdown dropdown-table-actions">
                                    <Link href="javascript:;" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false" className="">
                                        <i className="ri-more-fill"></i>
                                    </Link>
                                    {/* Class_Id=${Class}&FYear=${SelectedYear}&SelectedMonth=${SelectedMonth}&Wing=${WingName}&className=${ClassName} */}
                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                        {/* <li><Link to={`/Setup/UpdateSection/${item.Section_ID} `} className="dropdown-item"><i className="ri-edit-line"></i> Edit</Link></li>
                                        <li><Link onClick={(e) => deleteSection(item.Section_ID)} className="red dropdown-item"><i className="ri-delete-bin-line"></i>Delete</Link></li> */}
                                        <li ><Link to={`/PrintReports/SectionWiseClassList/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Student List</Link></li>
                                        <li><Link to={`/PrintReports/RPTAwardListClass/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Award List</Link></li>
                                        <li><Link to={`/PrintReports/Classwiseattendancesheet/${item.Class_Id}`} target="_blank" className="dropdown-item" ><i className="ri-printer-line"></i>Print Attendence Sheet</Link></li>
                                        <li><Link to={`/PrintReports/AbsentListClassWise/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Absentee List</Link></li>
                                        <li><Link to={`/PrintReports/PrintBioDataFormsList/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print BioData Forms</Link></li>
                                        <li><Link to={`/PrintReports/PrintStudentCardsList/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Student Cards</Link></li>

                                        <li><Link to={`/PrintReports/PrintTestPerformaList/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Test Performa</Link></li>
                                        <li><Link to={`/PrintReports/PrintOralAssessmentReport1/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Oral Assessment Report 1</Link></li>
                                        <li><Link to={`/PrintReports/PrintOralAssessmentReport1Urdu/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Oral Assessment Report 1 Urdu</Link></li>
                                        <li><Link to={`/PrintReports/PrintOralAssessmentReport2Urdu/${item.Class_Id}`} target="_blank" className="dropdown-item"><i className="ri-printer-line"></i>Print Oral Assessment Report 2 Urdu</Link></li>

                                    </ul>
                                </div>
                            </td>
                        </tr>
                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colSpan="7"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }


    const deleteClass = (ID) => {

        // Show a confirmation alert
        const userConfirmed = window.confirm('Are you sure you want to delete this class?');

        if (userConfirmed) {
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                Class_Id: ID
            };

            var api_config = {
                method: 'post',
                url: config.base_url + 'WingClass/DeleteClassByClassID',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };


            axios(api_config)
                .then(function (response) {
                    if (response.data.status_code == 1) {
                        setIsUpdated(true);
                    }
                    setIsUpdated(false);

                })
                .catch(function (error) {
                    //console.log(error);
                });
        }

    }


    return (
        <>
            <SetupMenu />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"> <Link to="/Setup/SetupDashboard">Setup</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Manage Classes</li>
                                </ol>
                            </nav>
                            <div className="page-title">Manage Classes</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/Setup/AddClass" className="button button-white button-icon">
                                    Add Class
                                    <i className="ri-add-line"></i>
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-content">
                <div className="container">
                    <div className="card mb-2">
                        <div className="card-body p-md-4">
                            <div className="row align-items-center">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Select Session:</label>
                                        <select className="form-select" name="SessionId" onChange={(e) => setSessionId(e.target.value)}>
                                            <option value="0">---All---</option>
                                            <SessionsDropDown selectedSession={SessionID} />
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Select Wing:</label>
                                        <select
                                            onChange={(e) => {
                                                setWing_ID(e.target.value)
                                                const selectedText = e.target.options[e.target.selectedIndex].text;
                                                setWingName(selectedText);
                                            }}
                                            className="form-select" required>
                                            <option value="">Please Select</option>
                                            <WingsDropDown selectedWingId={Wing_ID} />
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="counting mt-4 text-end">
                                        <span className="">{totalRecords} </span> Records Found!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body table-wrap">
                            <table className="table table-theme table-hover">
                                <thead>
                                    <tr>
                                        <th>
                                            Class ID
                                        </th>
                                        <th>
                                            Class Code
                                        </th>
                                        <th>
                                            Class Short Name
                                        </th>
                                        <th>
                                            Class Name
                                        </th>
                                        <th>
                                            Wing Name
                                        </th>
                                        <th>
                                            Session
                                        </th>
                                        <th className="text-center">Action</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        loading ?
                                            <tr>
                                                <td className="text-center" colSpan="7">
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </td>
                                            </tr>
                                            :
                                            <>
                                                {renderLedger()}
                                            </>

                                    }
                                </tbody>
                            </table>
                            {
                                totalRecords > { pageSize } &&
                                <div className="pagination-wrap">

                                    <div className="row align-items-center">
                                        <div className="col-md-2 form_default">
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ fontSize: "15px" }}>Page Size</label>
                                                <div className="form-group">
                                                    <select className="form-select"
                                                        style={{ width: "100px" }}
                                                        onChange={(e) => {
                                                            setPageNo(1);
                                                            setPageSize(parseInt(e.target.value));


                                                        }}>
                                                        <option value="10" selected>10</option>
                                                        <option value="20">20</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="500">500</option>


                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <Pagination
                                            pageNo={pageNo}
                                            pageSize={pageSize}
                                            totalRecords={totalRecords}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>

                            }

                        </div>
                    </div>
                    <div className="card mt-md-3">
                        <div className="card-body">
                            <div className="row justify-content-end">
                                <div className="col-md-2">
                                    <NavLink
                                        target="_blank"
                                        to={`/Setup/PrintManageClasses/?wing_id=${Wing_ID}`}
                                        className="button button-primary w-100"
                                    >
                                        Print This Report
                                    </NavLink>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default ManageClasses;
